import { CRMAPIBase } from '@api/crmApiBase';
import { PaymentMethodsSettingResponse } from '@api/responseModels/paymentMethods/paymentMethodsSettingResponse';
import { PaymentMethodsSettingsResponse } from '@api/responseModels/paymentMethods/paymentMethodsSettingsResponse';
import { RequestResult } from '@api/responseModels/requestResult';

class PaymentMethodsGroup extends CRMAPIBase {
    async getPaymentMethodsSettings(
        crm_id: number
    ): Promise<RequestResult<PaymentMethodsSettingsResponse>> {
        const result = await this.get<PaymentMethodsSettingsResponse>(`payment-methods/setting`, {
            crm_id,
        });
        return result;
    }

    async updatePaymentMethodsSetting({
        crm_id,
        payment_method_id,
        enabled,
        photo_report,
        additional,
    }: {
        crm_id: number;
        payment_method_id: number;
        enabled: boolean;
        photo_report: boolean;
        additional: any;
    }): Promise<RequestResult<PaymentMethodsSettingResponse>> {
        const result = await this.post<PaymentMethodsSettingResponse>(`payment-methods/setting`, {
            crm_id,
            payment_method_id,
            enabled,
            photo_report,
            additional,
        });
        return result;
    }
}

export { PaymentMethodsGroup };
